var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShadow1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 548,
    height: 889,
    viewBox: "0 0 548 889",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.15,
    filter: "url(#filter0_f_42_1702)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: 41.5,
    cy: 392.5,
    rx: 256.5,
    ry: 246.5,
    fill: "url(#paint0_linear_42_1702)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_42_1702",
    x: -465,
    y: -104,
    width: 1013,
    height: 993,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 125,
    result: "effect1_foregroundBlur_42_1702"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_42_1702",
    x1: -184.673,
    y1: 639,
    x2: 359.387,
    y2: 561.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0EA5EA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0BD1D1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShadow1);
export default __webpack_public_path__ + "static/media/shadow-1.bf1af6f9d58e589e2203609cdecd14d7.svg";
export { ForwardRef as ReactComponent };